import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {useSelector} from 'react-redux'
import {http} from 'hiya-common/src/utils/axios'
import {getGuessCoinsType, GameType} from '../utils'

export enum ReturnStatus {
  失败 = 0,
  成功 = 1,
}

export enum RecordTabEnum {
  bet = 0,
  free = 1,
  guessCoins = 2,
}

export enum SwitchAction {
  开启 = 1,
  关闭 = 2,
}

export enum GuessCoinsStatus {
  不存在 = -1,
  不展示 = 0,
  未开启 = 1,
  已开启 = 2,
}

export enum GuessCoinsActivityStatus {
  未开始 = 0,
  进行中 = 1,
  展示期 = 2,
  已结束 = 3,
}

export enum GameStatusEnum {
  无 = 0,
  未开始 = 1,
  选择卡牌阶段 = 2,
  结果阶段 = 3,
  结算阶段 = 4,
}

export enum RankTabsEnum {
  金额 = 1,
  倍数 = 2,
}

// export enum GuessCoinsStatusEnum {
//   未开始状态 = 0, // 未开始
//   展示阶段 = 1,
//   选择阶段 = 2,
//   结果阶段 = 3, // （1）炸蛋结束 点击结束 （2）选中倍率 选择是否继续与结束 （3）指定倍率 点击结束
//   结算阶段 = 4, // 只有倍率结束才有这个阶段
// }

export enum UserOptionEnum {
  接受 = 1,
  拒绝 = 2,
}

export enum BetStatusEnum {
  下注失败 = 0,
  下注成功 = 1,
  余额不足 = 2,
}

// 使用不同的游戏类型
// 猜金币信息相关 初始化时必须提前掉用 http://wiki.xunlei.cn/pages/viewpage.action?pageId=132046646
export const guess_coin_act_homepage = createAsyncThunk(
  '/live/game/guess_coin_act_homepage',
  async (arg: any, store: any) => {
    const resp = await http.post(
      '/live/game/guess_coin_act_homepage',
      {
        game_type: getGuessCoinsType(),
        ...arg,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 猜金币游戏接受/拒绝开始玩 http://wiki.xunlei.cn/pages/viewpage.action?pageId=132046676
export const guess_coin_start = createAsyncThunk(
  '/live/game/guess_coin_start',
  async (arg: any, store: any) => {
    const {deviceinfo} = store.getState().env
    const resp = await http.post(
      '/live/game/guess_coin_start',
      {
        ...arg,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 猜金币游戏主接口
export const guess_coin_homepage = createAsyncThunk(
  '/live/game/guess_coin_homepage',
  async (arg, store: any) => {
    const {deviceinfo} = store.getState().env
    const resp = await http.post(
      '/live/game/guess_coin_homepage',
      {},
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 猜金币游戏选择
export const guess_coin_card_select = createAsyncThunk(
  '/live/game/guess_coin_card_select',
  async (arg: any, store: any) => {
    const {deviceinfo} = store.getState().env
    const resp = await http.post(
      '/live/game/guess_coin_card_select',
      {
        ...arg,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 猜金币游戏结束游戏
export const guess_coin_settle = createAsyncThunk(
  '/live/game/guess_coin_settle',
  async (arg: any, store: any) => {
    const {deviceinfo} = store.getState().env
    const resp = await http.post(
      '/live/game/guess_coin_settle',
      {
        ...arg,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 猜金币游戏下一关
export const guess_coin_next = createAsyncThunk(
  '/live/game/guess_coin_next',
  async (arg: any, store: any) => {
    const {deviceinfo} = store.getState().env
    const resp = await http.post(
      '/live/game/guess_coin_next',
      {
        ...arg,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 猜金币-功能开关 http://wiki.xunlei.cn/pages/viewpage.action?pageId=151062188
export const guess_coin_toggle = createAsyncThunk(
  '/live/game/guess_coin_toggle',
  async (arg: {action: SwitchAction}, store: any) => {
    const resp = await http.post(
      '/live/game/guess_coin_toggle',
      {
        game_type: getGuessCoinsType(),
        ...arg,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 猜金币-奖励明细 http://wiki.xunlei.cn/pages/viewpage.action?pageId=132049131
export const guess_coin_record = async (arg: any) => {
  const resp = await http.post('/live/game/guess_coin_record', {
    ...window.store.getState().env.deviceinfo,
    game_type: getGuessCoinsType(),
    limit: 10,
    page_size: 10,
    offset: 0,
    ...arg,
  })
  return resp.data.data
}

export enum CardEnum {
  炸弹 = 1,
  金币 = 2,
}

export enum StartStatusEnum {
  等级阶段 = 1,
  宝箱阶段 = 2,
  选择阶段选择 = 3,
  结果阶段 = 4,
}

interface GuessCoinMultipleCard {
  id: number
  multiple: number
  icon: string
  type: CardEnum
  name: string
  is_high?: boolean
}
interface GuessCoin {
  id?: number
  status?: GameStatusEnum
  countdown?: number
  bet?: number
  reward?: number
  level?: number
  multiple?: number
  hit_multiple_id?: number
  has_next?: boolean
  res_ids?: Array<number>
  is_home_page?: boolean
}

interface InitialStateType {
  guessCoins?: {
    config?: {
      max_bet_coin?: number
      start_time?: string
      end_time?: string
    }
    countdown?: number // 自然周倒计时
    function_status?: GuessCoinsStatus
    activity_status?: GuessCoinsActivityStatus
    has_guess_coin?: boolean
  }
  homePage?: GuessCoin
  multiple_cards?: Array<GuessCoinMultipleCard>
  gamePlayIng?: boolean
  fresh?: boolean
  isComplete?: boolean
  maxMultiple?: number
  showFingerGuide?: boolean // 手指引导，默认不展示
}

const initData = {
  guessCoins: {},
  gamePlayIng: false,
  homePage: {
    countdown: 120,
  },
  fresh: false,
  isComplete: false,
  maxMultiple: 10000, // 最大倍率前端写死
  showFingerGuide: false,
}
const initialState: InitialStateType = {}

export const GuessCoinsSlice = createSlice({
  name: 'GuessCoins',
  initialState,
  reducers: {
    initData: (state, action) => {
      Object.assign(state, initData)
    },
    setGamePlaying: (state, action: PayloadAction<boolean>) => {
      Object.assign(state, {
        gamePlayIng: action.payload,
      })
    },
    updateHomePage: (state, action: PayloadAction<GuessCoin>) => {
      Object.assign(state, {
        homePage: {
          ...action.payload,
          countdown: action.payload?.countdown || 0,
        },
      })
    },
    freshPage: (state, action: PayloadAction<boolean>) => {
      Object.assign(state, {
        fresh: action.payload,
      })
    },
    changeFingerGuide: (state, action: PayloadAction<boolean>) => {
      Object.assign(state, {
        showFingerGuide: action.payload,
      })
    },
    setIsComplete: (state, action: PayloadAction<boolean>) => {
      Object.assign(state, {
        isComplete: action.payload,
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(guess_coin_act_homepage.fulfilled, (state, action) => {
      Object.assign(state.guessCoins, action.payload)
    })
    builder.addCase(guess_coin_start.fulfilled, (state, action) => {
      const {status, guess_coin} = action.payload
      // 下注成功 改变主状态
      if (status === BetStatusEnum.下注成功) {
        Object.assign(state.homePage, {...guess_coin, is_home_page: false})
      }
    })
    builder.addCase(guess_coin_homepage.fulfilled, (state, action) => {
      const {guess_coin, multiple_cards} = action.payload
      Object.assign(state, {
        homePage: {
          ...guess_coin,
          is_home_page: true,
          countdown: guess_coin?.countdown || 0,
        },
        multiple_cards,
      })
    })
    builder.addCase(guess_coin_card_select.fulfilled, (state, action) => {
      const {guess_coin} = action.payload
      Object.assign(state.homePage, {
        ...guess_coin,
        is_home_page: false,
        has_next: guess_coin?.has_next,
      })
    })
    builder.addCase(guess_coin_settle.fulfilled, (state, action) => {
      const {guess_coin} = action.payload
      // 是无奖励定时器清0，有奖励展示结算
      Object.assign(state, {
        homePage: {
          ...guess_coin,
          is_home_page: false,
        },
      })
    })
    builder.addCase(guess_coin_next.fulfilled, (state, action) => {
      const {guess_coin} = action.payload
      Object.assign(state.homePage, {...guess_coin, is_home_page: false})
    })
  },
})
export default GuessCoinsSlice.reducer
export const useGuessCoinsState = () => {
  return useSelector((state) => state.Animal_Dove)
}
export const GuessCoinsActions = GuessCoinsSlice.actions
